// Autogenerated file
export const ratingsEnum = {
    None: "None",
    Good: "Good",
    Bad: "Bad",
};
export const ratings = [
    { label: "Не хочу оценивать", value: "None" },
    { label: "Хорошо", value: "Good" },
    { label: "Плохо", value: "Bad" },
];
